import i18next from "i18next";
import {initReactI18next} from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import Backend from "i18next-http-backend";

i18next
    .use(initReactI18next)
    .use(LanguageDetector)
    .use(Backend)
    .init({
        fallbackLng: "en",
        debug: true,
        interpolation: {
            escapeValue: false,
            format: function (value, format) {
                if (format === "uppercase") return value.toUpperCase();
                if (format === "lowercase") return value.toLowerCase();
                if (format === "capitalize") return value[0].toUpperCase() + value.slice(1);
                if (format === "date_format_long") {
                    return new Intl.DateTimeFormat(
                        i18next.language || "en",
                        {day: "numeric", month: "long", year: "numeric"}).format(new Date(value));
                }
                if (format === "date_format_short") {
                    return new Intl.DateTimeFormat(
                        i18next.language || "en",
                        {day: "2-digit", month: "2-digit"}).format(new Date(value));
                }
                if (format === "time_format_normal") {
                    return new Intl.DateTimeFormat(
                        i18next.language || "en",
                        {hour: "2-digit", minute: "2-digit", second: "2-digit"}).format(new Date(value));
                }
                if (format === "datetime_format_xxhmm-dd/mm") {
                    return new Intl.DateTimeFormat(
                        i18next.language || "en",
                        {
                            hour: "2-digit",
                            minute: "2-digit",
                            day: "2-digit",
                            month: "2-digit"
                        }).format(new Date(value)).replace(" ", " - ");
                }
                return value;
            },
        }
    });

export default i18next;
